import Vue from 'vue'
import store from '@/store'
import { listByBizId, listDisposition, queryFiledLanguageList } from '@api/api'
import { langInputModal } from '@comp/mtcModule/mtcLangInputModal'
import { getLanguageEnable } from '@/utils/util'

// 设置表单回填值参数
function setFormValue({ field, data }) {
  let mainLang = Vue.ls.get('language') || 'zh-cn'
  if (!field || !data || !mainLang) {
    console.log('【langUtils.setFieldLangData】方法缺少必要参数')
    return
  }
  return {
    field,
    value: data[ mainLang ]
  }
}

// 根据后端返回的多语言源数据，转化前端的驼峰字段为数据库的下划线字段
function getRelField(tableName, field) {
  let dataSourceMap = store.getters.tableSourceLangMap
  let sourceData = dataSourceMap[ tableName ]
  // 使用后端返回该表的多语言字段源数据，匹配获取到对应的relField字段
  if (!sourceData) return field
  return sourceData.find(k => k.relEntityAttribute === field)?.relField || field
}

/**
 * 获取远程指定字段多语言详情
 * @params field   字段
 * @params id      业务数据id
 * @params tableName   表名
 * */
export function getLangFieldDetail({ field, id, tableName }) {
  if (!tableName || !field || !id) {
    console.log('【langUtils.getLangFieldDetail】方法缺少必要参数')
    return []
  }
  let params = {
    relField: getRelField(tableName, field),
    relBizId: id,
    relTable: tableName
  }
  return queryFiledLanguageList(params).then(res => {
    return res.result
  })
}

/**
 * 根据业务id和表名、字段获取vuex中的数据多语言信息数组，仅限主表
 * @params field   字段
 * @params id      业务数据id
 * @params tableName   表名
 * */
export function setInputParams({ tableName, field, id = '' }) {
  let dataMap = store.getters.langFieldMap
  if (!tableName || !field) {
    console.log('【langUtils.setInputParams】方法缺少必要参数')
    return []
  }
  return dataMap[ `${tableName},${field},${id}` ] || []
}

/**
 * 根据业务id和表名、字段获取vuex中的数据多语言信息数组，仅限子表
 * @params field   字段
 * @params list    当前行中已有的多语言数组信息
 * @params subTableName   子表表名
 * */
export function setSubInputParams({ subTableName, field, list = [] }) {
  if (!list?.length) return []
  return list.filter(ele => ele.relField === field && ele.relTable === subTableName) || []
}

// 根据当前表名获取当前业务中开启数据多语言的字段  relTable  表名
export function getLanguageField(relTable) {
  if (!relTable) return console.log('【langUtils.getLanguageField】方法缺少必要参数')
  return listDisposition({ relTable }).then(res => {
    const data = res?.result || []
    store.commit('SET_LANGFIELDSOURCEMAP', { [ relTable ]: data })
    let fieldArr = data.map(ele => ele.relEntityAttribute)
    // data 接口返回的值  fieldArr 开启多语言的字段数组如:['name']
    return {
      data,
      fieldArr
    }
  })
}

// 校验是否是多语言字段
export function checkField(field, data) {
  if(!getLanguageEnable()) return false
  if (!field || !data) {
    console.log('【langUtils.checkField】方法缺少必要参数')
    return
  }
  return data.includes(field)
}

/**
 * 打开数据多语言信息录入模态框，仅限主表
 * @params tableName   表名
 * @params field       字段名
 * @params id          业务数据id
 * @params detail      已有数据，type Array
 * @params require     是否必填
 * @params type        main主表，children子表
 * */
export function openLangInputModal({ tableName, field, id = '', detail, require = true }, callBack, type = 'main') {
  let fieldObj = { field, detail, id, require, tableName }
  if (!tableName || !field || !callBack) {
    console.log('【langUtils.openLangInputModal】方法缺少必要参数')
    return
  }
  /**
   * content对象结构
   * data        多语言数据对象
   * langArr     多语言数据对象
   * field       多语言数据数组
   * tableName   当前设置数据多语言的字段
   * id          当前设置数据多语言的表名
   * */
  langInputModal(fieldObj, content => {
    // 主表的多语言数据存vuex，子表的要随到列表行数据中所以不存
    type === 'main' && setFieldLangData(content)
    // 回填表单需要的字段和value
    let backData = setFormValue(content)
    callBack(backData, content)
  })
}

// 主表数据多语言字段数据录入后存到vuex中
export function setFieldLangData({ langArr, field, tableName, id }) {
  if (!tableName || !field) {
    console.log('【langUtils.setFieldLangData】方法缺少必要参数')
    return
  }
  let saveLang = {
    [ `${tableName},${field},${id || ''}` ]: langArr
  }
  store.commit('SET_LANGFIELDMAP', saveLang)
}

// 主表设置数据多语言参数
export function setLangInputParams(tableName = '', id = '') {
  if (!tableName) {
    console.log('【langUtils.setLangInputParams】方法缺少必要参数')
    return
  }
  let sysLanguageList = []
  let dataMap = store.getters.langFieldMap
  let arr = Object.values(dataMap)
  sysLanguageList = arr.reduce((pre, next) => {
    return pre.concat(next)
  }, [])
  if (!tableName) return sysLanguageList
  let content = sysLanguageList.filter(k => {
    // 编辑时要匹配跟编辑数据id相同的数据
    if(id) return  k.relTable === tableName && k.relBizId === id
    // 新增时候要匹配id为空的
    return k.relTable === tableName && !k.relBizId
  })
  // 使用后端返回该表的多语言字段源数据，匹配获取到对应的relField字段
  content.map(ele => ele.relField = getRelField(tableName, ele.relField))
  return content
}

// 保存成功后清空VUEX中的langFieldMap数据
export function resetLangFieldMap() {
  store.commit('SET_LANGFIELDMAP', null)
}

/**
 * 获取列表数据多语言信息
 * @param ids   逗号分割的业务数据主键id字符串
 * @param data  列表数据
 * @param fieldArr  当前主表列表中有数据多语言字段
 * */
export function getTableDataLang(ids, data, fieldArr) {
  if (!ids) {
    console.log('【langUtils.getTableDataLang】方法缺少必要参数')
    return
  }
  return listByBizId({ bizIds: ids }).then(res => {
    const result = res.result
    if (!result || !result.length) return
    let langObj = {}
    result?.forEach(ele => {
      langObj[ `${ele.relBizId},${ele.relField}` ] = result.filter(k => k.relBizId === ele.relBizId && k.relField === ele.relField)
    })
    store.commit('SET_TABLELANGLIST', langObj)
    let dataList = []
    // 替换列表中展示的值为当前设置的主语言的值
    data?.forEach(item => {
      fieldArr.forEach(ele => {
        let newValue = getLangListById(item.id, ele)
        if (newValue) item[ ele ] = newValue
      })
      dataList.push(item)
    })
    return dataList?.length? dataList: data
  })
}

// 根据数据id和字段code获取列表数据中的多语言信息
function getLangListById(id, field) {
  let mainLang = Vue.ls.get('language') || 'zh-cn'
  let langObj = store.getters.tableLangMap
  if (!langObj[ `${id},${field}` ]) return ''
  return langObj[ `${id},${field}` ]?.find(lang => lang.langType === mainLang)?.langText || ''
}

// 多语言列表表头转换
export function changeLangColumn(data) {
  let arr = []
  data.forEach(ele => {
    let slotName = ele?.language_key || ele.title
    let obj = {
      ...ele,
      slotName,
      scopedSlots: { customRender: ele.dataIndex, title: slotName }
    }
    delete obj.title
    arr.push(obj)
  })
  console.log(arr, '转换后')
  return arr
}

// 获取次语言list
export function popLists(languageKey, that) {
  let secondLanguage = JSON.parse(that.$ls.get('secondLanguage')) || []
  if (!languageKey) return {}
  let secondLabel = secondLanguage.map(ele => {
    return {
      langType: ele,
      langText: that.$t(languageKey, ele) || that.$t('tip.noData')
    }
  })
  return secondLabel
}